import React, { useState, useEffect } from "react";
import "../css/NoNetworkStatusModal.css";
import { Modal } from "@mui/material";

const NoNetworkStatusModal = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  // Function to actively check network connectivity
  const checkNetworkStatus = async () => {
    try {
      // Try to fetch a small resource to confirm actual connectivity
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      const response = await fetch('https://www.google.com/favicon.ico', {
        mode: 'no-cors',
        cache: 'no-store',
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      setIsOffline(false);
      return true;
    } catch (error) {
      console.error("Network check failed:", error);
      setIsOffline(true);
      return false;
    }
  };

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
    };

    const handleOnline = async () => {
      await checkNetworkStatus();
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Initial check on component mount
    const runInitialCheck = async () => {
      await checkNetworkStatus();
    };
    runInitialCheck();

    // Set up a periodic check every 10 seconds while the modal is showing
    const intervalId = setInterval(async () => {
      if (isOffline) {
        await checkNetworkStatus();
      }
    }, 10000);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      clearInterval(intervalId);
    };
  }, [isOffline]);

  const handleRetry = async () => {
    await checkNetworkStatus();
  };

  return (
    <Modal className="no-network-popup" open={isOffline} onOk={handleRetry}>
      <div className="no-network-popup-content">
        <p>Check your internet connection and try again.</p>
        <button onClick={handleRetry}>Retry</button>
      </div>
    </Modal>
  );
};

export default NoNetworkStatusModal;
